const initialState = {
  hostApi: '',
  userId: '',
  referringUserId: '',
  addPipeEid: '',
  addPipeHash: '',
  themeId: '',
  IsCCM: '',
  CCMUserId: '',
  CCMReferringUserId: '',
  userRoles: [],
  ivId: null,
  isCCMContact:''

};

export const setAuthParams = (state, { payload }) => ({
  ...state,
  ...payload,
});

export default initialState;
